var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerReserve = function SvgPowerReserve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3884",
    transform: "translate(-1069 -2091)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ebebeb",
    "data-name": "Ellipse 675",
    transform: "translate(1069 2091)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3882",
    transform: "translate(849.793 1785.377)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M245.93 321.495c.168-.044.308-.095.48-.127s.322-.067.465-.1l.96-.2-.331-1.306-.332-1.314-.94.279-.456.135c-.156.041-.348.121-.531.183l-1.165.425-1.108.487c-.174.081-.347.148-.5.231s-.306.158-.442.23l-.909.473.5.983.5.97.863-.363.418-.176c.148-.063.31-.11.475-.172l1.033-.358c.347-.093.692-.189 1.02-.28",
    "data-name": "Path 4608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m250.14 320.795.892-.036c.137 0 .272-.015.436-.015l.53.006.567.008h.258-.028.017l.266.022 1.036.081.243.018.258.037.469.069.97.143.177-1.693.181-1.7-.979-.063c-.147-.009-.3-.018-.473-.031l-.26-.015h-2.079l-.146.011-.565.038-.53.037c-.171.014-.352.04-.509.058-.637.077-1.06.129-1.06.13l.165 1.45Z",
    "data-name": "Path 4609"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m238.879 322.305-.782.591-.378.286c-.135.101-.278.233-.425.355l-.921.79-.854.833c-.133.135-.271.255-.385.387l-.329.363c-.405.451-.676.751-.676.75l.547.5.545.5.691-.65.334-.315c.116-.115.257-.217.391-.332l.856-.71.881-.64c.146-.1.264-.2.413-.292l.4-.254c.5-.315.828-.525.828-.525l-.563-.812Z",
    "data-name": "Path 4610"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M228.918 336.837s-.081.382-.2.958l-.1.465c-.036.165-.054.346-.084.53l-.167 1.152-.095 1.154c-.013.183-.038.361-.035.531s-.006.328-.008.476l-.018.981h.054l.1-.974q.023-.216.047-.471c.024-.255.051-.341.076-.522l.187-1.129.253-1.111c.045-.178.075-.348.124-.508s.093-.315.136-.456l.28-.938-.265-.069Z",
    "data-name": "Path 4611"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m232.554 328.725-.528.826-.255.4c-.092.139-.176.309-.27.473l-.575 1.041c-.172.361-.343.722-.5 1.062-.077.171-.164.329-.222.491s-.122.31-.179.45l-.365.926.36.145.349.143s.172-.346.427-.865l.206-.42c.067-.15.166-.3.253-.454.179-.312.372-.644.563-.978l.617-.927c.1-.147.184-.291.29-.425s.2-.26.288-.378l.593-.78-.523-.364Z",
    "data-name": "Path 4612"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "m273.75 338.265.152.851.073.412c.026.146.037.3.058.462.035.32.073.661.112 1l.046.94c0 .158.023.271.017.456v.474c0 .415-.006.728-.008.88v.1l6.265-.2-.07-.976-.035-.474c-.012-.168-.042-.39-.066-.6l-.176-1.353c-.079-.438-.168-.866-.247-1.27-.043-.2-.076-.4-.123-.58s-.093-.357-.136-.516l-.282-1.059-2.788.726Z",
    "data-name": "Path 4613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "m270.8 331.075.448.756q.102.17.217.364c.115.194.144.275.222.419.148.292.309.6.468.915l.38.883q.046.106.092.206l.043.1.045.12.162.447.335.919 2.566-1.054 2.573-1.057-.409-.891q-.094-.2-.2-.43l-.054-.118-.218-.416-.628-1.183-.672-1.087c-.109-.17-.2-.341-.315-.492l-.3-.427-.628-.88-2.07 1.458Z",
    "data-name": "Path 4614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m264.555 319.927-.431-.2c-.15-.069-.355-.143-.542-.217l-1.2-.462-1.186-.37c-.192-.055-.371-.123-.548-.161l-.5-.121-1.024-.246-.434 1.761-.433 1.752.862.285.416.137c.148.043.3.116.456.176l.984.4c.311.15.622.3.914.439.15.075.279.126.427.211s.286.159.414.231l.857.476.93-1.841.93-1.844Z",
    "data-name": "Path 4615"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "m273.094 326.004-.695-.691-.336-.335c-.119-.119-.287-.26-.435-.4-.313-.279-.649-.574-.984-.871l-.993-.771c-.161-.121-.306-.248-.46-.347l-.429-.291-.883-.6-1.227 1.789-1.225 1.783.695.562.337.269c.122.093.235.211.36.321l.771.706.686.716c.112.119.21.205.321.341l.309.361.635.746 1.772-1.641Z",
    "data-name": "Path 4616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M252.809 320.759h.013z",
    "data-name": "Path 4617"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M252.818 337.728a6.114 6.114 0 1 0 6.114 6.114 6.114 6.114 0 0 0-6.114-6.114m0 10.654a4.54 4.54 0 1 1 4.539-4.539 4.54 4.54 0 0 1-4.539 4.543Z",
    "data-name": "Path 4619"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "m260.821 325.735-4.461 8.742-8.452 16.566a1 1 0 0 0-.07.159 1.569 1.569 0 1 0 2.935 1.109l6.661-17.621Z",
    "data-name": "Path 4618"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.142,
    cy: 3.142,
    r: 3.142,
    fill: "#0e2240",
    "data-name": "Ellipse 757",
    transform: "translate(249.676 340.701)"
  })))));
};
export { SvgPowerReserve as ReactComponent };
export default "/_next/static/images/powerReserve.svg";